import React, { useEffect, useState } from 'react'
import { getUserReferal } from '../../waitlist/services/waitlist-service';
import ReferedFriends from '../../waitlist/components/ReferedFriends';
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import { Button } from 'reactstrap';
import { utils } from "../../core/helpers/utils";

function ReferredFriends(props) {
    const history = useHistory();
    const [referrals, setReferrals] = useState([]);
    const [loader, setLoader] = useState(false);

    const handleClick = () =>{
        history.push('/refer')
     }

    useEffect(() => {
        getUserReferal().then((result) => {
            const response = utils.parsePayload(result);
            setLoader(true)
            if (!response || !response.success) {
               console.log("err");
            }

            if (response.data && response.data.referral && response.data.referral.length) {
                setLoader(false)
                setReferrals([...response.data.referral])
            }
        });
    }, [])

    return (
        referrals.length ?
            <ReferedFriends referrals={referrals}
                isMobile={props.isMobile} /> : 
                <div className="w-100 mt-5 pt-5 text-center">
                <h2 className="text-center"> No Referrals yet </h2>
                <Button onClick={handleClick}>Refer Now</Button>
             </div>
    )
}

export default ReferredFriends